<template>
  <img
    v-if="isLoading || isLoadingLP"
    class="app-loader"
    src="../assets/img/oval.svg"
    width="50"
    alt=""
  />
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Project',
  computed: {
    ...mapState('projects', ['isLoading']),
    ...mapState('landingpage', ['isLoadingLP'])
  }
}
</script>

<style lang="scss" scoped></style>
